import { render, staticRenderFns } from "./PapercleanConfigurazioneDizionariViewPage.vue?vue&type=template&id=6c18e81a"
import script from "./PapercleanConfigurazioneDizionariViewPage.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneDizionariViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports